module.exports = __webpack_public_path__ + "static/media/toast-icon_WARNING_24px.de043030.svg";